import React, { useState, useEffect } from "react";
import { renderModelNames, getGroupCodenames } from './modelNames';
import { Trans } from "react-i18next";

const PermissionTable = ({ permissionOptions, onPermissionChange, parentPermissions, selectedGroup }) => {
  const handlePermissionChange = (event) => {
    const value = parseInt(event.target.value);
    const isChecked = event.target.checked;

    if (isChecked) {
      onPermissionChange([...parentPermissions, value]);
    } else {
      const filteredList = parentPermissions.filter((item) => item !== value);
      onPermissionChange(filteredList);
    }
  };
  const generateGroupSelectionLogic = (groupConfig) => {
    const { codenamesToSelect, selectAll } = groupConfig;

    return () => {
      if (selectAll) {
        const allPermissionIds = permissionOptions.map((option) => option.id);
        onPermissionChange(allPermissionIds);
      } else {
        const permissionIdsToSelect = permissionOptions
          .filter((option) => codenamesToSelect.includes(option.codename))
          .map((option) => option.id);
        onPermissionChange(permissionIdsToSelect);
      }
    };
  };

  useEffect(() => {
    const groupSelectionLogic = {};
  
    for (let group = 1; group <= 7; group++) {
      groupSelectionLogic[group] = generateGroupSelectionLogic({
        selectAll: group === 1,
        codenamesToSelect: getGroupCodenames(group),
      });
    }
  
    if (selectedGroup && groupSelectionLogic[selectedGroup]) {
      groupSelectionLogic[selectedGroup]();
    }
  }, [selectedGroup, permissionOptions]);
  
  return (
    <div>
      <table className="table table-sm border">
        <thead>
          <tr>
            {/* <th className="text-left"><Trans>ID</Trans></th> */}
            <th className="text-left"><Trans>Name</Trans></th>
            <th className="text-left"><Trans>Module</Trans></th>
            <th className="text-center"><Trans>Permission</Trans></th>
          </tr>
        </thead>
        <tbody>
          {permissionOptions.map((i) => (
            <tr key={i.id}>
              {/* <td className="text-left">{i.id}</td>   */}
              <td className="text-left"><Trans>{i.name}</Trans></td>  
              <td className="text-left"><Trans>{renderModelNames(i.name)}</Trans></td>
              <td className="text-center">
                <label>
                  <input
                    type="checkbox"
                    onChange={handlePermissionChange}
                    value={i.id}
                    checked={parentPermissions.includes(i.id) }
                    name="perm"
                  />
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default PermissionTable;
